import { fetcher } from "helpers/fetcher";

import {
  TAddJobListingWorkingHoursReq,
  TAddJobListingWorkingHoursRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addJobListingWorkingHours = async (
  payload: TAddJobListingWorkingHoursReq
) => {
  return await fetcher<
    TAddJobListingWorkingHoursRes,
    TAddJobListingWorkingHoursReq["data"]
  >(ENDPOINT.CORPORATION.ADD_JOB_LISTING_WORKING_HOURS, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationAddJobListingWorkingHours = async (
  payload: TAddJobListingWorkingHoursReq
) => {
  return (await addJobListingWorkingHours(payload)).data;
};

mutationAddJobListingWorkingHours._key = (
  payload: TAddJobListingWorkingHoursReq
) => [ENDPOINT.CORPORATION.ADD_JOB_LISTING_WORKING_HOURS.url, payload];
